import { lazy } from 'react';

const Referral = lazy(() =>
  import(/* webpackChunkName: "referral" */ './Referral'));

const MagicCarpet = lazy(() =>
  import(/* webpackChunkName: "magic-carpet" */ './MagicCarpet'));

const CheckRewardReferral = lazy(() =>
  import(/* webpackChunkName: "check-reward" */ './CheckReward'));

export { Referral, MagicCarpet, CheckRewardReferral };
